module.exports = __webpack_public_path__ + "img/ic-close.f171c06b.svg";